import React, { useEffect, Suspense, lazy, createElement } from 'react';
import { Box, Container, Heading, Text, VStack, SimpleGrid, Divider, Image } from '@chakra-ui/react';
import { ServiceSection } from '../components/ServiceSection';
import { CTAButton } from '../components/CTAButton';
import { StickyTopBar } from '../components/StickyTopBar';
import { FloatingWhatsAppButton } from '../components/FloatingWhatsAppButton';
const LiveActivityCounter = lazy(() => import('../components/LiveActivityCounter').then(m => ({
  default: m.LiveActivityCounter
})));
const TestimonialsSection = lazy(() => import('../components/TestimonialsSection').then(m => ({
  default: m.TestimonialsSection
})));
export function LandingPage() {
  const whatsappUrl = 'https://wa.me/+16058247498';
  const phoneUrl = 'tel:+16055406973';
  useEffect(() => {
    // Tawk.to Script - defer by 5 seconds to prioritize page content
    if (typeof window === 'undefined') return;
    const tawkTimeout = setTimeout(() => {
      var s1 = document.createElement('script');
      var s0 = document.getElementsByTagName('script')[0];
      if (!s0 || !s0.parentNode) {
        document.head.appendChild(s1);
      } else {
        s0.parentNode.insertBefore(s1, s0);
      }
      s1.async = true;
      s1.src = 'https://embed.tawk.to/6839ef8f9796bf190d6448da/1ish4vion';
      s1.charset = 'UTF-8';
      s1.setAttribute('crossorigin', '*');
    }, 5000);
    return () => clearTimeout(tawkTimeout);
  }, []);
  return <Box bg="#0a0a0a" minH="100vh" w="full" data-id="element-56">
      {/* Sticky Top Bar */}
      <StickyTopBar whatsappUrl={whatsappUrl} data-id="element-57" />

      {/* Floating WhatsApp Button */}
      <FloatingWhatsAppButton whatsappUrl={whatsappUrl} data-id="element-58" />

      {/* Hero Section */}
      <Box position="relative" pt={{
      base: 12,
      md: 20
    }} pb={{
      base: 12,
      md: 16
    }} overflow="hidden" data-id="element-59">
        <Box position="absolute" top={0} left={0} right={0} bottom={0} zIndex={0} data-id="element-60">
          <Image src="https://cdn.magicpatterns.com/uploads/vcEBSogWdf7QtPCTn7govW/freepik__the-style-is-candid-image-photography-with-natural__67051.png" alt="Energía mística" w="full" h="full" objectFit="cover" filter="brightness(0.3)" data-id="element-61" />
          <Box position="absolute" top={0} left={0} right={0} bottom={0} bgGradient="linear(to-b, rgba(220, 38, 38, 0.3), rgba(10, 10, 10, 0.95))" data-id="element-62" />
        </Box>

        <Container maxW="container.xl" position="relative" zIndex={1} data-id="element-63">
          <VStack spacing={4} textAlign="center" data-id="element-64">
            <Heading as="h1" fontSize={{
            base: '3xl',
            md: '5xl',
            lg: '6xl'
          }} fontWeight="black" textTransform="uppercase" letterSpacing="tighter" color="white" lineHeight="shorter" maxW="900px" textShadow="0 0 20px rgba(255, 255, 255, 0.5), 0 0 40px rgba(220, 38, 38, 0.6)" data-id="element-65">
              ¿TE ESTÁN QUITANDO LO QUE ES TUYO?
            </Heading>

            <Text fontSize={{
            base: 'lg',
            md: 'xl',
            lg: '2xl'
          }} color="gray.300" maxW="800px" lineHeight="short" fontStyle="italic" data-id="element-66">
              Si se está alejando… Si ya no te busca como antes… Si duerme
              diferente… Si hay alguien más ocupando tu lugar…
            </Text>

            <Text fontSize={{
            base: 'xl',
            md: '2xl'
          }} color="brand.400" fontWeight="bold" mt={2} data-id="element-67">
              No es coincidencia.
            </Text>

            <Text fontSize={{
            base: 'lg',
            md: 'xl'
          }} color="gray.200" fontWeight="semibold" data-id="element-68">
              Es energía moviéndose en tu contra.
            </Text>

            <Box w="full" maxW="800px" mt={4} borderRadius="lg" overflow="hidden" boxShadow="0 0 30px rgba(220, 38, 38, 0.3)" data-id="element-69">
              <video controls playsInline preload="metadata" style={{
              width: '100%',
              height: 'auto',
              display: 'block'
            }} src="https://ydgkmdmvhrniztrhtrxq.supabase.co/storage/v1/object/sign/audio%20receta/pikaso-untitled-project-2026-02-24%20(1)%20(1).mp4?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV80NDNkYTY1ZS1iYWM1LTQyYWQtODMzNS1iNWE4N2M0NDYxNmQiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJhdWRpbyByZWNldGEvcGlrYXNvLXVudGl0bGVkLXByb2plY3QtMjAyNi0wMi0yNCAoMSkgKDEpLm1wNCIsImlhdCI6MTc3MTk0NjE4NywiZXhwIjoxODAzNDgyMTg3fQ.ebZjLehfAIRaBVSlgjJoKb7-PYejbjE9GZhJP6ATi5s" data-id="element-70">
                Tu navegador no soporta el elemento de video.
              </video>
            </Box>

            <Text fontSize="xs" color="gray.400" mt={0} fontStyle="italic" maxW="800px" data-id="element-71">
              Martha Molina: Ella sabe y reconoce nuestros conocimientos reales
            </Text>

            <Box borderTop="2px solid" borderColor="fire.500" pt={4} mt={4} w="full" maxW="600px" data-id="element-72">
              <Heading as="h2" fontSize={{
              base: '2xl',
              md: '3xl'
            }} color="fire.400" textTransform="uppercase" mb={4} fontWeight="black" textShadow="0 0 15px rgba(245, 158, 11, 0.8), 0 0 30px rgba(220, 38, 38, 0.5)" data-id="element-73">
                ACTÚA ANTES DE QUE SEA TARDE
              </Heading>

              <VStack spacing={3} data-id="element-74">
                <CTAButton href={whatsappUrl} size="xl" w="full" maxW="500px" data-id="element-75">
                  ESCRÍBENOS AHORA POR WHATSAPP
                </CTAButton>

                <CTAButton href={phoneUrl} size="xl" w="full" maxW="500px" bg="blue.600" bgGradient="linear(to-r, blue.600, blue.700)" _hover={{
                bgGradient: 'linear(to-r, blue.500, blue.600)',
                transform: 'scale(1.02)',
                filter: 'brightness(1.2)'
              }} data-id="element-76">
                  LLAMAR AHORA
                </CTAButton>
              </VStack>

              <Text fontSize="sm" color="gray.400" mt={2} data-id="element-77">
                Atención privada e inmediata
              </Text>
            </Box>
          </VStack>
        </Container>
      </Box>

      {/* Positioning Section */}
      <Box position="relative" py={{
      base: 12,
      md: 16
    }} mt={12} overflow="hidden" data-id="element-78">
        <Box position="absolute" top={0} left={0} right={0} bottom={0} zIndex={0} data-id="element-79">
          <Image src="https://images.unsplash.com/photo-1604881991720-f91add269bed?w=800&q=70" alt="Tradición ancestral" w="full" h="full" objectFit="cover" filter="brightness(0.25)" loading="lazy" data-id="element-80" />
          <Box position="absolute" top={0} left={0} right={0} bottom={0} bg="rgba(26, 26, 26, 0.7)" data-id="element-81" />
        </Box>

        <Container maxW="container.lg" position="relative" zIndex={1} data-id="element-82">
          <VStack spacing={6} textAlign="center" data-id="element-83">
            <Heading as="h2" fontSize={{
            base: '2xl',
            md: '4xl'
          }} color="brand.400" textTransform="uppercase" fontWeight="black" letterSpacing="wide" textShadow="0 0 20px rgba(220, 38, 38, 0.8), 0 0 40px rgba(220, 38, 38, 0.4)" data-id="element-84">
              AQUÍ NO DAMOS CONSEJOS. TRABAJAMOS ENERGÍA REAL.
            </Heading>

            <Text fontSize={{
            base: 'lg',
            md: 'xl'
          }} color="gray.300" maxW="800px" lineHeight="tall" data-id="element-85">
              No somos motivadores. No hacemos "ritualitos" genéricos.
            </Text>

            <Text fontSize={{
            base: 'lg',
            md: 'xl'
          }} color="white" maxW="800px" lineHeight="tall" fontWeight="semibold" data-id="element-86">
              Somos practicantes de tradición ancestral con más de 40 años de
              experiencia.
            </Text>

            <Text fontSize={{
            base: 'md',
            md: 'lg'
          }} color="gray.400" maxW="700px" mt={4} data-id="element-87">
              Cada caso se analiza. Cada ritual se prepara exclusivamente para
              una persona. Cada proceso se trabaja con intención firme.
            </Text>

            <Box bg="rgba(220, 38, 38, 0.1)" borderWidth="2px" borderColor="brand.500" borderRadius="md" p={6} mt={6} data-id="element-88">
              <Text fontSize={{
              base: 'lg',
              md: 'xl'
            }} color="fire.400" fontWeight="bold" data-id="element-89">
                Si aceptamos tu caso, es porque vemos movimiento posible.
              </Text>
            </Box>

            <CTAButton href={whatsappUrl} mt={8} data-id="element-90">
              CONSULTA TU CASO AHORA
            </CTAButton>
          </VStack>
        </Container>
      </Box>

      {/* Live Activity Counter - Floating Notifications */}
      <Suspense fallback={null} data-id="element-91">
        <LiveActivityCounter data-id="element-92" />
      </Suspense>

      {/* Services Section */}
      <Container maxW="container.xl" py={{
      base: 12,
      md: 20
    }} data-id="element-93">
        <SimpleGrid columns={{
        base: 1,
        lg: 3
      }} spacing={8} data-id="element-94">
          <ServiceSection imageUrl="https://cdn.magicpatterns.com/uploads/wmoq8U6ujmtp9hKFZSLm6E/freepik__create-a-logo-featuring-two-real-people-an-african__48719.jpg" title="DOMINACIÓN ATRACCIÓN REGRESIÓN ENERGÉTICA" description="Cuando dos personas se desconectan, el vínculo no desaparece… se debilita. Y lo que se debilita… puede reactivarse." features={['Enlace emocional', 'Intensificación de deseo', 'Recuperación de atención', 'Desbloqueo de interferencias', 'Reordenamiento energético del vínculo']} ctaText="INICIA TU PROCESO HOY" ctaHref={whatsappUrl} variant="highlighted" data-id="element-95" />

          <ServiceSection imageUrl="https://cdn.magicpatterns.com/uploads/dk9mQGgEQPHabcM6NvRidH/Captura_de_pantalla_2025-02-26_103828_(1).png" title="CORTE Y ALEJAMIENTO DE TERCERAS PERSONAS" description="Cuando alguien interfiere en tu relación… Cuando sientes que te están desplazando… Cuando una presencia rompe tu estabilidad… Se puede trabajar el corte energético." features={['Se debilitan conexiones', 'Se enfrían vínculos', 'Se separan caminos', 'Con protección espiritual y guía experta']} ctaText="RECUPERA TU LUGAR" ctaHref={whatsappUrl} data-id="element-96" />

          <ServiceSection imageUrl="https://cdn.magicpatterns.com/uploads/fZSvWUfPPMxEtiAyE4NKRd/Captura_de_pantalla_2025-05-30_225505_(1).png" title="APERTURA DE CAMINOS Y ABUNDANCIA" description="Si el dinero no fluye… Si todo se estanca… Si sientes bloqueo constante… No siempre es falta de esfuerzo. A veces es carga energética." features={['Rituales de apertura de caminos', 'Activación de prosperidad', 'Movimiento de energías estancadas', 'Atracción de estabilidad']} ctaText="ACTIVA TU PROSPERIDAD" ctaHref={whatsappUrl} data-id="element-97" />
        </SimpleGrid>
      </Container>

      {/* Warning Section */}
      <Box position="relative" borderTop="2px solid" borderBottom="2px solid" borderColor="brand.600" py={{
      base: 12,
      md: 16
    }} overflow="hidden" data-id="element-98">
        <Box position="absolute" top={0} left={0} right={0} bottom={0} zIndex={0} data-id="element-99">
          <Image src="https://images.unsplash.com/photo-1516339901601-2e1b62dc0c45?w=800&q=70" alt="Exclusividad" w="full" h="full" objectFit="cover" filter="brightness(0.2)" loading="lazy" data-id="element-100" />
          <Box position="absolute" top={0} left={0} right={0} bottom={0} bg="rgba(153, 27, 27, 0.4)" data-id="element-101" />
        </Box>

        <Container maxW="container.md" position="relative" zIndex={1} data-id="element-102">
          <VStack spacing={6} textAlign="center" data-id="element-103">
            <Heading as="h2" fontSize={{
            base: '2xl',
            md: '4xl'
          }} color="brand.400" textTransform="uppercase" fontWeight="black" textShadow="0 0 20px rgba(220, 38, 38, 0.8), 0 0 40px rgba(220, 38, 38, 0.4)" data-id="element-104">
              ESTO NO ES PARA TODOS
            </Heading>

            <Text fontSize={{
            base: 'lg',
            md: 'xl'
          }} color="gray.300" lineHeight="tall" data-id="element-105">
              Si dudas de todo. Si solo tienes curiosidad. Si no estás dispuesto
              a seguir indicaciones.
            </Text>

            <Text fontSize={{
            base: 'xl',
            md: '2xl'
          }} color="white" fontWeight="bold" lineHeight="tall" data-id="element-106">
              Este no es tu lugar.
            </Text>

            <Text fontSize={{
            base: 'lg',
            md: 'xl'
          }} color="fire.400" fontWeight="semibold" data-id="element-107">
              Trabajamos con personas decididas.
            </Text>

            <Text fontSize={{
            base: 'lg',
            md: 'xl'
          }} color="gray.200" fontWeight="semibold" data-id="element-108">
              Personas que no quieren seguir perdiendo.
            </Text>
          </VStack>
        </Container>
      </Box>

      {/* Testimonials Section */}
      <Suspense fallback={null} data-id="element-109">
        <TestimonialsSection data-id="element-110" />
      </Suspense>

      {/* Final Urgency Section */}
      <Box position="relative" py={{
      base: 12,
      md: 20
    }} overflow="hidden" data-id="element-111">
        <Box position="absolute" top={0} left={0} right={0} bottom={0} zIndex={0} data-id="element-112">
          <Image src="https://images.unsplash.com/photo-1501139083538-0139583c060f?w=800&q=70" alt="El tiempo corre" w="full" h="full" objectFit="cover" filter="brightness(0.25)" loading="lazy" data-id="element-113" />
          <Box position="absolute" top={0} left={0} right={0} bottom={0} bgGradient="linear(to-b, transparent, rgba(220, 38, 38, 0.2))" data-id="element-114" />
        </Box>

        <Container maxW="container.lg" position="relative" zIndex={1} data-id="element-115">
          <VStack spacing={8} textAlign="center" data-id="element-116">
            <Heading as="h2" fontSize={{
            base: '3xl',
            md: '5xl'
          }} color="white" textTransform="uppercase" fontWeight="black" letterSpacing="tight" textShadow="0 0 20px rgba(255, 255, 255, 0.5), 0 0 40px rgba(220, 38, 38, 0.6)" data-id="element-117">
              NO LLEGASTE AQUÍ POR ACCIDENTE
            </Heading>

            <Text fontSize={{
            base: 'lg',
            md: 'xl'
          }} color="gray.300" maxW="700px" lineHeight="tall" data-id="element-118">
              Si estás leyendo esto…
            </Text>

            <Text fontSize={{
            base: 'xl',
            md: '2xl'
          }} color="fire.400" fontWeight="bold" maxW="700px" data-id="element-119">
              Es porque algo dentro de ti sabe que el tiempo corre.
            </Text>

            <Box my={8} data-id="element-120">
              <Text fontSize={{
              base: 'md',
              md: 'lg'
            }} color="gray.400" mb={2} data-id="element-121">
                Cada día que pasa sin actuar…
              </Text>
              <Text fontSize={{
              base: 'lg',
              md: 'xl'
            }} color="gray.300" data-id="element-122">
                La distancia crece. El frío aumenta. La energía cambia.
              </Text>
            </Box>

            <Divider borderColor="brand.600" maxW="400px" data-id="element-123" />

            <Box mt={8} data-id="element-124">
              <Text fontSize={{
              base: 'xl',
              md: '2xl'
            }} color="white" fontWeight="bold" mb={6} data-id="element-125">
                La pregunta es simple:
              </Text>
              <Text fontSize={{
              base: 'lg',
              md: 'xl'
            }} color="gray.300" lineHeight="tall" data-id="element-126">
                ¿Vas a mirar cómo lo pierdes… o vas a intervenir?
              </Text>
            </Box>

            <Box bg="rgba(0, 0, 0, 0.6)" borderWidth="2px" borderColor="fire.500" borderRadius="lg" p={{
            base: 8,
            md: 12
          }} mt={12} w="full" maxW="700px" data-id="element-127">
              <Heading as="h3" fontSize={{
              base: '2xl',
              md: '3xl'
            }} color="fire.400" textTransform="uppercase" mb={8} fontWeight="black" textShadow="0 0 15px rgba(245, 158, 11, 0.8), 0 0 30px rgba(220, 38, 38, 0.5)" data-id="element-128">
                ÚLTIMA OPORTUNIDAD PARA ACTUAR
              </Heading>

              <VStack spacing={4} data-id="element-129">
                <CTAButton href={whatsappUrl} w="full" size="lg" fontSize={{
                base: 'sm',
                md: 'md'
              }} py={6} whiteSpace="normal" height="auto" lineHeight="1.3" data-id="element-130">
                  WHATSAPP DIRECTO
                  <br data-id="element-131" />
                  RESPUESTA INMEDIATA
                </CTAButton>

                <CTAButton href={phoneUrl} w="full" size="lg" fontSize={{
                base: 'sm',
                md: 'md'
              }} py={6} bg="blue.600" bgGradient="linear(to-r, blue.600, blue.700)" borderColor="blue.500" color="white" _hover={{
                bgGradient: 'linear(to-r, blue.500, blue.600)',
                transform: 'scale(1.02)',
                filter: 'brightness(1.2)'
              }} className="" data-id="element-132">
                  LLAMADA PRIVADA
                </CTAButton>

                <CTAButton href={whatsappUrl} w="full" size="lg" fontSize={{
                base: 'sm',
                md: 'md'
              }} py={6} whiteSpace="normal" height="auto" lineHeight="1.3" data-id="element-133">
                  QUIERO EMPEZAR MI
                  <br data-id="element-134" />
                  PROCESO AHORA
                </CTAButton>
              </VStack>
            </Box>
          </VStack>
        </Container>
      </Box>

      {/* Footer */}
      <Box bg="rgba(10, 10, 10, 0.95)" py={8} borderTop="1px solid" borderColor="gray.800" data-id="element-135">
        <Container maxW="container.xl" data-id="element-136">
          <Text textAlign="center" color="gray.500" fontSize="sm" data-id="element-137">
            Tradición ancestral • Más de 40 años de experiencia • Atención
            personalizada
          </Text>
        </Container>
      </Box>
    </Box>;
}